import React from 'react'
import EngAttendanceContent from '../../Component/EngAttendance/EngAttendanceContent'

function EngAttendance() {
  return (
    <div className="mt-32">
      <EngAttendanceContent />
    </div>
  )
}

export default EngAttendance

